import { postRequest } from '../utils/axiosUtils';
import { API_URL } from '../config/config';

export const loginAdminUser = async (username, password, rememberMe) => {
  if (!username || !password) {
    throw new Error('Username and password are required.');
  }

  const response = await postRequest({
    url: `${API_URL}/auth/admin/sign-in`,
    data: { userName: username, password, rememberMe },
  });

  if (response.status >= 200 && response.status < 300 && response.data) {
    return response.data;
  } else {
    const errorMessage = `Unexpected response code: ${response.status}`;
    throw new Error(errorMessage);
  }
};


export const loginUser = async (username, password) => {
  if (!username || !password) {
    throw new Error('Username and password are required.');
  }

  const response = await postRequest({
    url: `${API_URL}/auth/sign-in`,
    data: { userName: username, password },
  });

  if (response.status >= 200 && response.status < 300 && response.data) {
    return response.data;
  } else {
    const errorMessage = `Unexpected response code: ${response.status}`;
    throw new Error(errorMessage);
  }
};